<div class="auto-group-source-item-container">
  <div class="filter-selection">
    <div [ngClass]="{'filter-col-4': hasMultipleValues, 'filter-col-3': !hasMultipleValues}">
      <div class="filter-type">
        <auto-group-filter-box [options]="supportedFilterOptions"
                               [(model)]="autoGroupFilter.type"
                               name="auto_group_filter_{{autoGroupFilter.index}}"
                               (selectEvent)="selectFilter()"
                               placeholder="{{'new_group_settings.dropdown_placeholder' | translate}}">
        </auto-group-filter-box>
      </div>
      <div *ngIf="firstFilterValues.length > 0 && hasMultipleValues" class="filter-value-1">
        <auto-group-filter-box [options]="firstFilterValues"
                               [(model)]="autoGroupFilter.firstValue"
                               placeholder="{{'new_group_settings.dropdown_placeholder' | translate}}"
                               (modelChange)="checkAndClearPreviousErrors()"
                               name="first_filter_value_{{autoGroupFilter.index}}">
        </auto-group-filter-box>
      </div>
      <div class="filter-comparison">
          <div *ngIf="hasSingleComparison" class="source-operator-content">
            <div class="single-operator">{{operatorList[0].name}}</div>
          </div>
          <auto-group-filter-box *ngIf="hasMultipleComparison"
                                 [options]="operatorList"
                                 [(model)]="autoGroupFilter.comparison"
                                 (selectEvent)="selectComparison($event)"
                                 placeholder="{{'new_group_settings.dropdown_placeholder' | translate}}"
                                 name="filter_comparison_{{autoGroupFilter.index}}">
          </auto-group-filter-box>
      </div>
      <div class="filter-value-2">
        <auto-group-filter-box *ngIf="secondFilterValues.length > 0"
                               [options]="secondFilterValues"
                               [(model)]="autoGroupFilter.secondValue"
                               placeholder="{{'new_group_settings.dropdown_placeholder' | translate}}"
                               [multiple]="isMultipleSelect"
                               (selectEvent)="selectSecondFilterValue($event)"
                               name="second_filter_value_{{autoGroupFilter.index}}">
        </auto-group-filter-box>
      </div>
    </div>
  </div>
  <div class="filter-action">
    <div class="button-icon icon-delete">
      <a class="icon-delete" (click)="deleteGroupFilter()"></a>
    </div>
    <span class="error-msg" *ngIf="errorMessage">{{errorMessage}}</span>
    <span class="warning-msg" *ngIf="warningMessage">{{warningMessage}}</span>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/group-details/new-group-settings/auto-group-filters/auto-group-filter-item/auto-group-filter-item.component.html